import "core-js/modules/es.array.map.js";
import React from 'react';
import styled, { withTheme } from 'styled-components';
var StyledFeature = styled.div.withConfig({
  displayName: "Feature__StyledFeature",
  componentId: "sc-9tuh6g-0"
})(["display:inline;svg{vertical-align:text-top;}svg + svg{margin-left:2px;}"]);
export var Feature = function Feature(_ref) {
  var value = _ref.value,
    theme = _ref.theme;
  var color = theme.colors.accent1;
  if (!value) {
    return React.createElement(StyledFeature, null, [1, 2, 3, 4].map(function (star, index) {
      return React.createElement("svg", {
        key: index,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
        fill: theme.colors.ui
      }));
    }));
  }
  return React.createElement(StyledFeature, null, [1, 2, 3, 4].map(function (star, index) {
    return value >= star ? React.createElement("svg", {
      key: index,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
      fill: color
    }), React.createElement("circle", {
      r: "4",
      transform: "matrix(-1 0 0 1 8 8)",
      fill: color
    })) : React.createElement("svg", {
      key: index,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
      fill: color
    }));
  }));
};
export default withTheme(Feature);